<script>
import { mapActions } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';
import ModalFormComponent from '@/components/debts_bill/ModalDebtsBillFormComponent.vue';

export default {
    components: {
        ModalFormComponent,
    },
    props: {
        prop_edit: {
            default: true,
        }
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            send: false,
            load: false,
            bills: [],
            id: 0,
        }
    },
    methods: {
        deletePay(id){
			let tit = 'Eliminar pago';
            let txt = 'Seguro que quiere eliminar el pago';

            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancelar'
            }).then(async(result) => {
                if (result.isConfirmed) {
                    let _endpoint = `/dues_bill/${id}`;
					try {
						let response = await request.destroy(_endpoint).then(function (response) { return response; });
						this.list();
                        this.successNotification(response.data.message);
                    } catch (error) {
                        this.errors = await this.errorNotification(error)
                    }
                }
            });
        },
        async form(data = {}) {
            Event.$emit('event-show-addCreateBillFormDebts', this.id, data);
        },
        async list() {
            this.load = true;
            let service = request;
            let _endpoint = '/dues_bill?id=' + this.id;
            try {
                let { data } = await service.get(_endpoint)
                if (data) {
                    console.log(data);
                    this.bills = data;
                    this.load = false;
                }
            } catch (error) {
                console.log(error);
                this.load = false;
            }
        },
        closedModal() {
            this.load = false;
            this.errors = {};
            this.send = false;
            this.id = 0;
            this.bills = [];
            this.$modal.hide('addCreateBillDebt');
        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        })
    },
    created() {
        Event.$on("event-show-addCreateBillDebts", async (id) => {
            this.load = true;
            this.$modal.show('addCreateBillDebt');
            this.id = id;
            this.list();
            this.load = false;
        });
        Event.$on("event-show-loadBillFormDebts", async () => {
            this.list();
        });
    },
    watch: {

    }
}
</script>
<template>
    <modal name="addCreateBillDebt" :width="'80%'" :maxHeight="300" :height="'auto'" v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>

        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Facturar</h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-12 text-right">
                    <button type="button" @click="form()" class="btn btn-sm btn-outline-success mt-1 mb-1">
                        <i class="fa-solid fa-plus"></i>
                        Agregar Factura
                    </button>
                </div>
                <div class="col-md-12 table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Fecha</th>
                                <th>Comentarios</th>
                                <th>Opciones</th>
                            </tr>
                        </thead>
                        <tbody v-if="load">
                            <tr>
                                <td align="center" colspan="6">
                                    <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                    <h5>Cargando</h5>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else-if="bills.length > 0">
                            <tr v-for="(bill, index) in bills" :key="index">
                                <td>
                                    {{ bill.id }}
                                </td>
                                <td>
                                    {{ bill.date | toDateTime }}
                                </td>
                                <td>
                                    {{ bill.comment }}
                                </td>
                                <td>
                                    <a class="btn btn-sm btn-outline-success m-1" v-if="bill.xml"
                                        target="_blank"
                                        :href="`${globalUrlFiles}${bill.xml}`">
                                        <i class="fa-solid fa-file"></i>
                                        XML
                                    </a>
                                    <a class="btn btn-sm btn-outline-danger m-1" v-if="bill.pdf"
                                        target="_blank"
                                        :href="`${globalUrlFiles}${bill.pdf}`">
                                        <i class="fa-regular fa-file-pdf"></i>
                                        PDF
                                    </a>
                                   <button type="button" class="btn btn-sm btn-outline-success m-1"
                                        @click="form(bill)">
                                        <i class="fa-solid fa-file-pen"></i>
                                        Editar
                                    </button>
                                    <button type="button" class="btn btn-sm btn-outline-danger m-1"
                                        @click="deletePay(bill.id)">
                                        <i class="fa-solid fa-trash"></i>
                                        Eliminar
                                    </button> 
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td align="center" colspan="6">Sin resultados.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="col-md-12">
                    <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                        <i class="fas fa-undo-alt"></i>
                        Regresar
                    </button>
                </div>

            </div>
        </div>
        <ModalFormComponent :prop_edit="true" />
    </modal>
</template>